export default {
  SettingIndexesList: {
    indexCode: '索引',
    remark: '描述',
    copyIndex: '复制索引',
    updateUser: '最近更新人',
    lastUpdateDate: '最近更新时间',
    msgError: '复制失败',
    msgSuccess: '修改成功',

    details: {
      title: '基础信息',
      shards: '分片数量',
      replicas: '副本数量',
      syncField: '同步字段',
      fieldName: '字段名',
      fieldType: '字段类型',
      analyzerFlag: '是否索引',
      filedAnalyzerCode: '分词器',
      pkFlag: '是否主键',
      msgRulesText: '请输入索引',
      alertMsgText: '请输入同步字段信息 '
    }
  }
};
